<template>
  <div class="donor-overview donor-overview-show">
    <a href="#" class="close" v-on:click.prevent="$emit('close-info')"></a>

    <el-dropdown trigger="click"
                 @command="handleCommand"
                 class="float-right m-2"
    >
      <span class="el-dropdown-link inline-block text-gray-500 text-xl
      rounded-full h-8 w-8 flex items-center justify-center hover:bg-gray-200 ">
        <font-awesome-icon :icon="['far', 'ellipsis-v']"  />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :command="['edit']">
          <font-awesome-icon :icon="['fa', 'edit']"/> Edit Contact
        </el-dropdown-item>
        <el-dropdown-item v-if="donor && donorPhoneIsOn(donor)"
                          :command="['send-msg', donor.id]">
          <font-awesome-icon :icon="['fa', 'copy']"/> Send Message
        </el-dropdown-item>
        <el-dropdown-item v-if="isGodAdmin"
                          :command="['view-as-donor']">
          <font-awesome-icon :icon="['fa', 'eye']"/> View as Donor
        </el-dropdown-item>
        <el-dropdown-item :command="['delete-donor']">
          <font-awesome-icon :icon="['fa', 'trash-alt']"/> Delete Contact
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>


    <div class="profile">
      <div v-if="donorInitial" class="avatar">
        <img v-if="donorInitial.profile_photo"
             :src="donorInitial.profile_photo"
             :alt="`${donorInitial.first_name} ${donorInitial.last_name}`">
        <span v-else>{{{fname: donorInitial.first_name, lname: donorInitial.last_name} | shortName}}</span>
      </div>
      <div v-if="donorInitial" class="name">{{{fname: donorInitial.first_name, lname: donorInitial.last_name} |
        prepareName}}
      </div>
      <div v-if="donorInitial" class="contact">{{donorInitial.email}}</div>

      <div v-if="donor">
        <div v-if="!isEditMode && !donorInitial.donorIsDeleted">
          <a class="btn btn-sm-profile"
             v-on:click.prevent="isEditMode = true"
             href="#">Edit Contact</a>&nbsp;
          <router-link v-if="donorPhoneIsOn(donor)"
                       class="btn btn-sm-profile"
                       :to="{name: 'messagesNew', query: {'donor_ids': donor.id}}">Send Message
          </router-link>
        </div>
        <div v-if="donorInitial.donorIsDeleted">
          <button class="btn btn-danger btn-sm-profile" disabled
             >Deleted</button>
        </div>
        <div v-if="isEditMode" class="btn-wrap">
          <a class="btn btn-cancel btn-sm-profile"
             v-on:click.prevent="isEditMode = false"
             href="#">Cancel</a>&nbsp;
          <a class="btn btn-sm-profile"
             :class="{disabled: !isEdited}"
             :disabled="!isEdited"
             v-on:click.prevent="saveInfo"
             href="#">Save</a>&nbsp;
        </div>
      </div>
    </div>
    <div class="tabs-wrapper">
      <div>
        <a href="#" class="tab-title"
           :class="{'active': activeTab === 'overview'}"
           v-on:click="activeTab = 'overview'">Overview</a>
      </div>
      <div>
        <a href="#" class="tab-title"
           :class="{'active': activeTab === 'donations'}"
           v-on:click="activeTab = 'donations'">Donations</a>
      </div>
    </div>
    <div v-if="donor" class="tabs">
      <div id="tab-overview"
           :class="{'active': activeTab === 'overview'}"
           class="tab clearfix">
        <div class="donor-contacts">
          <div class="row">
            <div class="col-sm-8">
              <div class="info">Sign-up Date</div>
              <div class="item-title">{{donor.created_at | dateFormat('MMMM DD, YYYY')}}</div>
            </div>
            <div class="col-sm-4"></div>
            <div v-if="isEditMode" class="col-sm-8">
              <div class="info">Phone Number</div>
              <div class="item-title">

                <masked-input
                    type="text"
                    inputmode="numeric"
                    class="input-sm input-edit"
                    pattern="[0-9]{3}-[0-9]{3}-(([0-9]{3}\s)|[0-9]{4})"
                    v-model="donor.phone.number"
                    :mask="[/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                    :guide="true"
                    :placeholderChar="'\u2000'"
                    placeholder="xxx-xxx-xxxx"
                />

              </div>
            </div>
            <div v-else class="col-sm-8">
              <div class="info">Phone Number</div>
              <div class="item-title"><span class="donor-phone-number">
                  {{donorInitial.phone.number
                  ? donorInitial.phone.number.replace(/(\d{3})(\d{3})(\d{4,10})/, '$1-$2-$3')
                  : '-'}}
                </span>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="info">Texts</div>
              <div class="item-title" >
                <span class="status"
                      :class="{'txt-green': donorPhoneIsOn(donor), 'txt-red': !donorPhoneIsOn(donor)}"
                >{{donorPhoneIsOn(donor) ? 'ON' : 'OFF'}}</span>
              </div>
            </div>
            <div v-if="isEditMode && donorPhoneIsOn(donor)" class="col-sm-12 item-title">
              <a href="#"
                 v-on:click.prevent="turnMessagesOffModal = true"
                 class="msg-off">Turn Text Messages OFF</a>
            </div>
            <div v-if="isEditMode" class="col-sm-12">
              <div class="info">Email Address
                <span class="email-notice">Updating changes the donor's login email</span>
              </div>

              <div class="item-title">
                <input type="text" v-model="donor.email" class="input-sm input-edit">
              </div>
            </div>
            <div v-if="isEditMode" class="col-sm-12">
              <div class="info">First Name</div>
              <div class="item-title">
                <input type="text" v-model="donor.first_name" class="input-sm input-edit">
              </div>
            </div>
            <div v-if="isEditMode" class="col-sm-12">
              <div class="info">Last Name
              </div>
              <div class="item-title">
                <input type="text" v-model="donor.last_name" class="input-sm input-edit">
              </div>
            </div>

            <div class="col-sm-12 list-tags-wrap">
              <div>
                <div class="info">Lists</div>
                <div class="list-tags">
                  <span v-for="(list, index) in donor.lists"
                        :key="index"
                        class="tag"
                  >{{list.name}}<a v-on:click.prevent="deleteList(list.id)" href="#">+</a></span>
                  <span v-if="lists.length"
                        v-on:click.prevent="showAddListsBlock = !showAddListsBlock"
                        class="tag add-to-list-btn"><i class="fas fa-plus"></i>Add to a List
                  </span>
                </div>
              </div>

              <div v-if="lists.length && showAddListsBlock" class="lists-select">
                <div class="ls-title">ADD or REMOVE the user from Lists</div>
                <div class="ls-body">
                  <div class="ls-search">
                    <div class="search">
                      <input type="text" placeholder="Search" ref="listFilter" class="input-sm" v-model="listFilter">
                    </div>
                  </div>
                  <div class="ls-items">
                    <div class="lists-not-found" v-if="filteredLists.length === 0">Not Found</div>
                    <div v-for="(list, index) in filteredLists"
                         :key="index"
                         class="ls-item"
                         :class="{selected: inLists(list.id)}"
                         v-on:click.prevent="!inLists(list.id)?addList(list.id):deleteList(list.id); showAddListsBlock = false"
                    >{{list.name}}
                      <a v-if="inLists(list.id)"
                         v-on:click.prevent="deleteList(list.id); showAddListsBlock = false"
                         class="ls-rm"
                         href="#"
                      ><i class="fas fa-times-circle"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-8">
              <div class="info">Description & Info</div>
            </div>
            <div class="col-sm-4 info">(<a class="add-edit-description"
                                           v-on:click.prevent="isEditDescription = true"
                                           href="#">ADD/EDIT</a>)
            </div>
            <div class="col-sm-12 donor-desc">
              <p class="donor-desc-text" v-if="!isEditDescription">{{donorDescription || '...'}}</p>
              <div v-else>
                <textarea cols="30" rows="6" v-model="donorDescription"></textarea>
                <div class="btn-wrap text-right"><a
                    href="#"
                    v-on:click.prevent="isEditDescription = false; donorDescription=donor.description"
                    class="btn btn-sm btn-cancel btn-cancel-add-edit-desc"
                >Cancel</a><a
                    href="#"
                    v-on:click.prevent="updateDescription"
                    class="btn btn-sm btn-save-donor-desc">Save</a></div>
              </div>
            </div>
            <div v-if="donor && demographic && demographic.length" class="row">
              <div class="col-sm-12">
                <div class="col-sm-6"
                     v-for="(d, index) in demographic"
                     :key="index"
                >
                  <div class="info">{{d.column.name | ucwords}}</div>
                  <div class="item-title">{{d.value}}</div>
                </div>
              </div>
            </div>

            <div v-if="donor && (address || isEditMode)" class="row">
              <div class="col-sm-12">

                <div v-if="addressLine && !isEditMode" class="col-sm-12" style="white-space: pre-wrap">
                  <div class="info">Address</div>
                  <div class="item-title">{{addressLine}}</div>
                </div>
                <div v-else-if="isEditMode">
                  <div class="col-sm-3">
                    <div class="info">Address</div>
                    <div class="item-title">
                      <input type="text" v-model="address.street_number" class="input-sm input-edit">
                    </div>
                  </div>
                  <div class="col-sm-9">
                    <div class="info">&nbsp;</div>
                    <div class="item-title">
                      <input type="text" v-model="address.route" class="input-sm input-edit">
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="info">Address 2 (Room/Unit/Suite)</div>
                    <div class="item-title">
                      <input type="text" v-model="address.premise" class="input-sm input-edit">
                    </div>
                  </div>
                </div>

                <div v-if="addressInitial.locality || isEditMode" class="col-sm-6">
                  <div class="info">City</div>
                  <div v-if="isEditMode" class="item-title">
                    <input type="text" v-model="address.locality" class="input-sm input-edit">
                  </div>
                  <div v-else class="item-title">{{addressInitial.locality}}</div>
                </div>

                <div v-if="addressInitial.administrative_area_level_1 || isEditMode" class="col-sm-3">
                  <div class="info">State</div>
                  <div v-if="isEditMode" class="item-title">
                    <input type="text" v-model="address.administrative_area_level_1" class="input-sm input-edit">
                  </div>
                  <div v-else class="item-title">{{addressInitial.administrative_area_level_1}}</div>
                </div>

                <div v-if="addressInitial.postal_code || isEditMode" class="col-sm-3">
                  <div class="info">Zip&nbsp;Code</div>
                  <div v-if="isEditMode" class="item-title">
                    <input type="text" v-mo del="address.postal_code" class="input-sm input-edit">
                  </div>
                  <div v-else class="item-title">{{addressInitial.postal_code}}</div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <div v-if="donor.gender && donor.gender.id || isEditMode" class="col-sm-6">
                  <div class="info">Gender</div>
                  <div v-if="isEditMode && genders.length" class="item-title">
                    <select class="input-sm input-edit"
                            v-model="donor.gender.id"
                    >
                      <option v-for="gender in genders"
                              :key="gender.id"
                              :value="gender.id"
                      >{{gender.name}}
                      </option>
                    </select>
                  </div>
                  <div v-else class="item-title">{{donor.gender.name}}</div>
                </div>

                <div v-if="donor.birthday && !isEditMode" class="col-sm-3">
                  <div class="info">Age</div>
                  <div class="item-title">{{ageFromDate(donor.birthday)}}</div>
                </div>
                <div v-if="donor.birthday || isEditMode"
                     :class="{'col-sm-3': !isEditMode, 'col-sm-6': isEditMode}">
                  <div class="info">Birthday</div>
                  <div v-if="isEditMode" class="item-title">
                    <input type="date" v-model="donor.birthday" class="input-sm input-edit">
                  </div>
                  <div v-else class="item-title">{{donor.birthday | dateFormat('M/D/YY')}}</div>
                </div>

              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <div v-if="employmentInitial && employmentInitial.employer_name || isEditMode" class="col-sm-6">
                  <div class="info">Employer</div>
                  <div v-if="isEditMode" class="item-title">
                    <input type="text" v-model="employment.employer_name" class="input-sm input-edit">
                  </div>
                  <div v-else class="item-title">{{employmentInitial.employer_name}}</div>
                </div>
                <div v-if="employmentInitial && employmentInitial.occupation || isEditMode" class="col-sm-6">
                  <div class="info">Position</div>
                  <div v-if="isEditMode" class="item-title">
                    <input type="text" v-model="employment.occupation" class="input-sm input-edit">
                  </div>
                  <div v-else class="item-title">{{employmentInitial.occupation}}</div>
                </div>
              </div>
            </div>

            <div v-if="addedFields && addedFields.length" class="row">
              <div class="col-sm-12">
                <div class="col-sm-6"
                     v-for="(d, index) in addedFields"
                     :key="index"
                >
                  <div class="info">{{d.column.name | ucwords}}</div>
                  <div class="item-title">{{d.value}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="tab-donations"
           :class="{'active': activeTab === 'donations'}"
           class="tab clearfix">
        <div class="total-donations">

          <div v-if="!donationsInfoLoaded" class="text-center" style="margin: 20px">
            <font-awesome-icon class="txt-blue" :icon="['fas', 'spinner']" spin size="2x"/>
          </div>

          <table v-else-if="donationsInfo" class="table">
            <thead>
            <tr>
              <th class="txt-blue">TOTAL DONATIONS</th>
              <th class="txt-blue value">${{donationsInfo.lifetime_total_cents / 100 | formatMoney}}</th>
            </tr>
            </thead>
            <tbody v-if="donationsInfo.donations">
            <tr v-for="(donation, index) in donationsInfo.donations"
                :key="index">
              <td>
                <span content="Click to download receipt"
                      v-tippy
                      style="cursor: pointer; outline: none;"
                      v-on:click="$refs.receipt.generatePdf({...donation,
                      first_name: donor.first_name,
                      last_name: donor.last_name,
                      email: donor.email,
                      address: donor.address,
                      intended_amount: Number(donation.covered_fee) > 0 ? donation.amount - Number(donation.covered_fee) : donation.amount
                    }, activeCharityInfo);">
                  ${{donation.amount / 100 | formatMoney}} {{donation.type | activityTitle}}
            </span>

              </td>
              <td class="info">{{donation.created_at | dateFormat('M/D/YYYY', 'YYYY/MM/DD HH:mm:ss')}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <receipt ref="receipt"></receipt>
    <modal v-if="turnMessagesOffModal"
           v-on:close-modal="turnMessagesOffModal = false"
           v-on:ok-modal="turnMessagesOffModal = false; turnMessagesOff(donor.id)"
           :modal-name="'message-turn-off'">
      <div slot="body" class="desc">
        Are you sure you would like to turn messages OFF for:
        <br v-if="donor"><b>{{donor.first_name}} {{donor.last_name}}</b><br><br>
        <em>They'll no longer receive texts and this action can not be undone unless the user signs back up to receive
          texts</em>
      </div>
    </modal>

    <modal v-if="isDeleteContactModal"
           v-on:close-modal="isDeleteContactModal = false"
           v-on:ok-modal="isDeleteContactModal = false; deleteDonor()"
           :modal-name="'admin-remove'">
      <div slot="header">Delete Contact</div>
      <div slot="body" class="desc">
        <p>
          Are you sure you want to delete <b>{{donor.first_name}} {{donor.last_name}}</b>?
        </p>
        <label class="checkbox-container checkbox-container-label">Report As Spam
          <input v-model="reportAsSpam" type="checkbox">
          <span class="checkmark"></span>
        </label>
      </div>
      <span slot="okButtonText">Delete Contact</span>
    </modal>
  </div>
</template>

<script>
import {
  getDonor,
  getDonorDonations,

  updateDonor,
  deleteDonor,
  removeUserFromList,
  addUsersToList,
  patchDonorAddress,
  patchDonorEmployment,
  patchDonorPhoneNumber,
  patchDonorPersonalInfo,
  patchDonorPhone,
} from '@/utils/api';
  import donorMixin from '../../mixins/donor';
  import ToCoins from './ToCoins.vue';
  import Receipt from '../Receipt';
  import MaskedInput from 'vue-text-mask';
  import {EventBus} from '@/utils/event-bus';
  import Modal from '../Modal/index.vue';
  import {loginAndOpenWebApp} from "@/utils/web-app-api";
  import auth from "@/auth/authService";
  import {mapState} from "vuex";

  const moment = require('moment');

  export default {
    name: 'DonorInfo',
    props: ['donorId'],
    mixins: [donorMixin],
    components: {
      ToCoins,
      MaskedInput,
      Receipt,
      Modal
    },
    mounted() {

      try {
        const tokenData = auth.getToken().split('.');
        const data = JSON.parse(atob(tokenData[1]));

        if (data && data.client_id && data.client_id.search('god_admin_') === 0) {
          this.isGodAdmin = true;
        }
        // eslint-disable-next-line
      } catch (e) {}

      document.addEventListener('click', e => {
        if (this.showAddListsBlock && !e.target.closest('.lists-select') && !e.target.closest('.add-to-list-btn')) {
          this.showAddListsBlock = false;
        }
      });

      getDonor(this.donorId).then(donor => {
        this.setDonor(donor);

        this.setAddress(donor.address || {
          country: '',
          administrative_area_level_1: '',
          locality: '',
          street_number: '',
          route: '',
          premise: '',
          postal_code: '',
        });

      this.setEmployment(this.donor.employment || {employer_name: '', occupation: ''});

      this.donorDescription = donor.description;
      });

      this.$store.dispatch('donors/fetchGenders');
      this.$store.dispatch('lists/fetchLists', {charityId: this.activeCharityId});
    },
    methods: {
      handleCommand([command, payload]) {
        switch (command){
          case 'edit':
            this.isEditMode = true;
            break
          case 'send-msg':
            this.$router.push({name: 'messagesNew', query: {'donor_ids': payload}});
            break
          case 'view-as-donor':
            this.viewAsDonor();
            break
          case 'delete-donor':
            this.isDeleteContactModal = true;
            break
        }
      },
      viewAsDonor(){
        this.$store.dispatch('donors/createProxyToken', {
          userId: this.donorId,
        }).then(proxyToken => {
          loginAndOpenWebApp(this.activeCharityInfo, proxyToken.proxy.token)
        })
      },
      turnMessagesOff(uid) {
        patchDonorPhone(uid).then(() => {
          this.$message('Donor Messages Turned OFF');

          this.donor.phone.is_enabled = false;
          this.donorInitial.phone.is_enabled = false;
          setTimeout(() => EventBus.$emit('update-donors'), 200);
        })
      },
      ageFromDate(date) {
        return moment().diff(date, 'years', false);
      },
      inLists(id) {
        if (!parseInt(id) || !this.donor || !this.donor.lists) {
          return false;
        }
        for (let i = 0; i < this.donor.lists.length; i++) {
          if (parseInt(this.donor.lists[i].id) === parseInt(id)) {
            return true;
          }
        }
        return false;
      },
      updateDescription() {
        updateDonor(this.donorId, this.donorDescription).then(() => {
          this.donor.description = this.donorDescription;
          this.isEditDescription = false;
        });
      },
      deleteList(listId) {
        removeUserFromList(listId, this.donorId).then(() => {
          this.donor.lists = this.donor.lists.filter(v => v.id != listId);
        });
      },
      getListById(id) {
        for (let i = 0; i < this.lists.length; i++) {
          if (this.lists[i].id == id) {
            return this.lists[i];
          }
        }
      },
      addList(listId) {
        addUsersToList(listId, [this.donorId]).then(() => {
          let addedList = this.getListById(listId);

          if (addedList) {
            this.donor.lists.push({
              id: listId,
              name: addedList.name,
              description: addedList.description,
            });
          }
        });
      },
      setEmployment(info) {
        this.employment = Object.assign({}, info);
        this.employmentInitial = Object.assign({}, info);
      },
      setAddress(info) {
        this.address = Object.assign({}, info);
        this.addressInitial = Object.assign({}, info);

      },
      setDonor(info) {
        info.gender.id = info.gender.id || 0;
        info.gender.name = info.gender.name || '';
        info.phone.number = info.phone.number || '';
        info.donorIsDeleted = false

        const index = info.email.indexOf(' ');
        if(index!== -1) {
          info.donorIsDeleted = true
          info.email = info.email.slice(0, index)
        }

        let birthday = info.birthday || '';
        if (birthday !== '') {
          birthday = moment(birthday, 'YYYY-MM-DD').format('YYYY-MM-DD');
        }
        info.birthday = birthday;

        this.donor = JSON.parse(JSON.stringify(info));
        this.donorInitial = JSON.parse(JSON.stringify(info));
      },
      saveInfo() {
        let res = [];
        if (this.addressChanged) {
          res.push(this.saveAddress());
        }
        if (this.employmentChanged) {
          res.push(this.saveEmployment());
        }
        if (this.donorPhoneChanged) {
          res.push(this.savePhone());
        }
        if (this.donorInfoChanged) {
          res.push(this.saveDonorInfo());
        }

        Promise.all(res).then(() => {
          this.$message('Donor information updated');

          getDonor(this.donorId).then(donor => {
            this.setDonor(donor);
          });

          setTimeout(() => EventBus.$emit('update-donors'), 200);
          this.isEditMode = false;
          // eslint-disable-next-line
        }).catch(res => console.warn(res));
      },
      saveEmployment() {
        return new Promise((resolve, reject) => {
          patchDonorEmployment(this.donorId, {
            'employer_name': this.employment.employer_name,
            'occupation': this.employment.occupation,
          }).then((res) => {
            this.setEmployment(this.employment);
            resolve(res);
          }).catch(() => reject('An error has occurred, please try again.'));
        });
      },
      savePhone() {
        return new Promise((resolve, reject) => {
          patchDonorPhoneNumber(this.donorId, {
            'country_code': this.donor.phone.country_code,
            'phone_number': this.donor.phone.number,
            'enabled': this.donor.phone.is_enabled,
          }).then((res) => {
            resolve(res);
          }).catch(() => reject('An error has occurred, please try again.'));
        });
      },
      saveDonorInfo() {
        return new Promise((resolve, reject) => {
          patchDonorPersonalInfo(this.donorId, {
            'email': this.donor.email,
            'first_name': this.donor.first_name,
            'last_name': this.donor.last_name,
            'gender_id': this.donor.gender && this.donor.gender.id || 0,
            'birthday': this.donor.birthday && moment(this.donor.birthday).format('YYYY-MM-DD') || '', //YYYY-MM-DD
          }).then((res) => {
            resolve(res);
          }).catch(() => reject('An error has occurred, please try again.'));
        });
      },
      saveAddress() {
        return new Promise((resolve, reject) => {
          patchDonorAddress(this.donorId, {
              country: this.address.country,
              administrative_area_level_1: this.address.administrative_area_level_1,
              locality: this.address.locality,
              street_number: this.address.street_number,
              route: this.address.route,
              premise: this.address.premise,
              postal_code: this.address.postal_code,
              formatted_address: '',
              latitude: null,
              longitude: null,
            },
          ).then((res) => {
            this.setAddress(this.address);
            resolve(res);
          }).catch(() => reject('An error has occurred, please try again.'));
        });
      },
      deleteDonor() {
        return new Promise((resolve, reject) => {
          deleteDonor(this.donorId, this.activeCharityId, this.reportAsSpam)
            .then(res => { 
              setTimeout(() => EventBus.$emit('update-donors'), 50);
              this.$store.dispatch('donors/fetchAllDonors', {charityId: this.activeCharityId, force: true});
              this.$emit('close-info');
              resolve(res);
            })
            .catch(() => {
              this.$emit('close-info');
              reject('An error has occurred, please try again.')
            });
        });
      }
    },
    computed: {
      ...mapState({
        genders: state => state.donors.genders,
        lists: state => state.lists.lists,
        activeCharityId: state => state.auth.activeCharityId,
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
      demographic() {
        return this.donor.metadata.filter(v => ['age', 'gender'].indexOf(v.column.name) !== -1);
      },
      addedFields() {
        return this.donor.metadata.filter(v => ['age', 'gender'].indexOf(v.column.name) === -1);
      },
      addressLine() {
        if (!this.addressInitial) {
          return '';
        }
        return [
          this.addressInitial.street_number, this.addressInitial.route,
          (this.addressInitial.premise ? '\n' + this.addressInitial.premise : ''),
        ].filter(Boolean).join(' ');
      },
      filteredLists() {
        const self = this;
        const re = new RegExp(this.listFilter, 'ig');
        const lists = this.lists.filter(v => v.name.search(re) !== -1).reverse();

        function compare(a, b) {
          if (self.inLists(a.id) !== self.inLists(b.id)) {
            return self.inLists(a.id) ? -1000 : 1000;
          }

          if (a.name < b.name)
            return -1;
          if (a.name > b.name)
            return 1;
          return 0;
        }

        return lists.sort(compare);
      },
      employmentChanged() {
        return JSON.stringify(this.employmentInitial) !== JSON.stringify(this.employment);
      },
      addressChanged() {
        return JSON.stringify(this.addressInitial) !== JSON.stringify(this.address);
      },
      donorInfoChanged() {
        const info = JSON.parse(JSON.stringify(this.donor));
        const info2 = JSON.parse(JSON.stringify(this.donorInitial));
        delete info.phone;
        delete info2.phone;

        return JSON.stringify(info2) !== JSON.stringify(info);
      },
      donorPhoneChanged() {
        const info = JSON.parse(JSON.stringify(this.donor));
        info.phone.number = info.phone.number.replace(/-/g, '');

        return JSON.stringify(this.donorInitial.phone) !== JSON.stringify(info.phone);
      },
      isEdited() {
        return this.employmentChanged || this.addressChanged || this.donorInfoChanged || this.donorPhoneChanged;
      },
    },
    watch: {
      'isEditMode' () {
        if (!this.isEditMode) {
          this.setDonor(this.donorInitial);
          this.setAddress(this.addressInitial);
          this.setEmployment(this.employmentInitial);
        }
      },
      'activeTab'() {
        if (this.activeTab === 'donations' && !this.donationsInfoLoaded) {
          getDonorDonations(this.donorId).then(donationsInfo => {
            this.donationsInfoLoaded = true;
            this.donationsInfo = donationsInfo;
          })
        }
      }
    },
    data() {
      return {
        activeTab: 'overview',//'donations'
        isGodAdmin: false,
        donorDescription: '',
        isEditDescription: false,

        donationsInfo: null,
        donationsInfoLoaded: false,
        listFilter: '',
        showAddListsBlock: false,

        isEditMode: false,
        isDeleteContactModal: false,
        reportAsSpam: false,

        donor: null,
        donorInitial: null,
        employment: null,
        employmentInitial: null,
        address: null,
        addressInitial: null,

        turnMessagesOffModal: false,
      };
    },
  };
</script>
<style lang="scss" scoped>
  input[type="date"]::-webkit-inner-spin-button,
  input[type="date"]::-webkit-clear-button {
    display: none;
  }

  .btn-wrap {
    .btn-cancel {
      border-color: #ced0da;
    }
  }

  .donor-contacts {
    .email-notice {
      display: inline-block;
      font-size: 10px;
      float: right;
      color: #f37f82;
    }

    .row {
      margin-left: -5px;
      margin-right: -5px;
    }

    .col-sm-12,
    .col-sm-8,
    .col-sm-9,
    .col-sm-6,
    .col-sm-4,
    .col-sm-3 {
      padding-left: 5px;
      padding-right: 5px;
    }

    .input-sm {
      padding: 4px 10px;
    }
  }
</style>
<style lang="sass" scoped>
  $color-btn-bg: #0d70e3

  @keyframes showDonorInfo
    0%
      right: -370px
    100%
      right: 0

  .donor-overview
    animation: showDonorInfo .3s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards

    .btn-danger
      background-color: #ed1c24
      border: none
      cursor: not-allowed

    .profile
      min-height: 150px

    .donor-desc-text
      white-space: pre-wrap

    .list-tags-wrap
      position: relative
      z-index: 5

    .lists-select
      position: absolute
      border-radius: 4px
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2)
      background-color: #ffffff
      z-index: 10
      overflow: hidden
      margin-top: -16px
      left: 15px
      right: 15px

      .lists-not-found
        font-size: 14px
        padding: 15px

      .ls-title
        height: 22px
        background-color: $color-btn-bg
        padding: 5px 15px
        font-size: 10px
        font-weight: 600
        line-height: 1.2
        color: rgba(255, 255, 255, 0.8)

      .ls-body
        padding: 10px 10px 0

        .ls-search
          margin-bottom: 10px

          .search
            width: 100%

      .ls-items
        max-height: 220px
        overflow-y: auto

        .ls-item
          padding: 5px 5px 5px 15px
          font-size: 12px
          font-weight: bold
          line-height: 1
          color: #050926
          cursor: pointer
          margin-bottom: 5px

          &.selected
            border-radius: 4px
            background-color: $color-btn-bg
            color: #ffffff

          .ls-rm
            float: right
            color: white


</style>
